import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDownload, FiRotateCcw } = FiIcons;

const logoUrl =
  'http://mindtechnology.ai/wp-content/uploads/2025/04/LOGO-100-X-100-MIND-TECHNOLOGY.png';

function Header({ onReset, onDownloadReport }) {
  return (
    <header className="topbar">
      <a
        className="brand"
        href="https://mindtechnology.ai"
        target="_blank"
        rel="noreferrer"
        aria-label="Visit Mind Technology"
      >
        <div className="brand-mark">
          <img src={logoUrl} alt="Mind Technology" />
        </div>
        <div className="brand-copy">
          <span className="brand-eyebrow">MIND TECHNOLOGY</span>
          <strong>Conference Budget Studio</strong>
        </div>
      </a>

      <div className="header-actions">
        <button className="button button-secondary" onClick={onReset}>
          <SafeIcon icon={FiRotateCcw} />
          <span>Reset</span>
        </button>
        <button className="button button-primary" onClick={onDownloadReport}>
          <SafeIcon icon={FiDownload} />
          <span>Download report</span>
        </button>
      </div>
    </header>
  );
}

export default Header;